export class AppConfig {
    public environment: string = "";
    public tenantId : string= "";
    public clientId: string = "";
    public baseUrl: string = "";
    public object_id: string = "";
    // Middleware API - For reading well data from ADLS
    public apiUrl: string = "";
    public wellsApiKey: string = "";
    // Outbound API - For pushing data to WellView DB 
    public outboundApiUrl: string = "";
    public outboundApiKey: string = "";
    // Hardcoded bearer token (for local development only)
    public access_token: string = "";
    public token_type: string = "";
}
